import { Message } from 'scripts/type'

export default function postMessage(message: Message) {
  window?.parent?.postMessage(message, '*')
  // @ts-ignore
  window?.webkit?.messageHandlers?.webViewMessageHandler?.postMessage(message)
  // @ts-ignore
  window?.XSDK?.postMessage(JSON.stringify(message))
  return { message }
}
